<ng-container *transloco="let t">
  <ld-base-modal [title]="t('commonAddBankAccountTermsLink')" [size]="'large'" (closeModal)="closeModal.emit()">
    <div modal-content>
      <p id="terms-content-1" class="font-dm text-sm text-ld-neutral leading-relaxed mb-4">
        {{ content1() }}
      </p>
      <p id="terms-content-2" class="font-dm text-sm text-ld-neutral leading-relaxed">
        {{ content2() }}
      </p>
    </div>
    <div modal-footer>
      <button
        id="terms-conditions-back-btn"
        type="button"
        class="btn-primary-ld-purple whitespace-nowrap px-8"
        (click)="onBack()"
      >
        {{ t('modalsTermsAndConditionsBackButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
